var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C2.44772 6 2 6.44772 2 7V16.2667C2 16.7766 2.38168 17.1974 2.87494 17.2589C2.86978 17.2178 2.86712 17.1758 2.86712 17.1333V7.86663C2.86712 7.31435 3.31484 6.86663 3.86712 6.86663H20.0671C20.1095 6.86663 20.1512 6.86927 20.1922 6.87438C20.1304 6.38139 19.7097 6 19.2 6H3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C0.447715 4 0 4.44772 0 5V14.2667C0 14.7766 0.38168 15.1974 0.874941 15.2589C0.869784 15.2178 0.867122 15.1758 0.867122 15.1333V5.86663C0.867122 5.31435 1.31484 4.86663 1.86712 4.86663H18.0671C18.1095 4.86663 18.1512 4.86927 18.1922 4.87438C18.1304 4.38139 17.7097 4 17.2 4H1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8C4.44772 8 4 8.44771 4 9V18C4 18.5523 4.44772 19 5 19H21C21.5523 19 22 18.5523 22 18V9C22 8.44772 21.5523 8 21 8H5ZM13 15.5C14.1046 15.5 15 14.6046 15 13.5C15 12.3954 14.1046 11.5 13 11.5C11.8954 11.5 11 12.3954 11 13.5C11 14.6046 11.8954 15.5 13 15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash-icon.6ed81584a37a9ada4175d7e6009d644c.svg";
export { ForwardRef as ReactComponent };